import http from '../interceptors/Intercepter';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

export const createNotificationInterval = async (username, notificationInterval) => {
  try {
    const params = { username };

    const { data } = await http.post('/api/notification-interval/create', notificationInterval, { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewNotificationInterval = async (username) => {
  try {
    const params = { username };

    const { data } = await http.get('/api/notification-interval/view', { ...config, params });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
